import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const CloseableAreaWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  ${props => {
    if (props.show) {
      return `display: block`;
    } else {
      return `display: none`;
    }
  }}
  ${props =>
    props.focus &&
    `&:before {
			width: 100%;
			height: 100%;
			content: '';
			margin-top: 64px;
			background-color: ${Variables.colors.complementary};
			opacity: .5;
			position: fixed;
		}`}
`;
